import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

/**
 * Sprint S-7 · Landing /r/:code · captura el código de afiliado en localStorage
 * y redirige a /register tras 1.5 s. Se persiste 60 días.
 */
export default function ReferralLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (code) {
      try {
        localStorage.setItem("ag_ref", code.toUpperCase());
        localStorage.setItem("ag_ref_ts", String(Date.now()));
      } catch (_e) { /* ignore quota */ }
    }
    const t = setTimeout(() => navigate("/register", { replace: true }), 1500);
    return () => clearTimeout(t);
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-[var(--ag-midnight)] text-[var(--ag-text)] grid place-items-center px-6">
      <div className="ag-card max-w-md w-full p-8 text-center" data-testid="referral-landing">
        <Sparkle size={36} weight="fill" className="text-[var(--ag-gold)] mx-auto" />
        <h1 className="font-display font-black text-3xl tracking-tighter mt-4">¡Te invitan a AutoGlow!</h1>
        <p className="text-[var(--ag-text-dim)] mt-3 text-sm">
          Has llegado con un enlace de referido. Te llevamos al registro para que pruebes la plataforma 30 días gratis.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 text-[var(--ag-gold)] uppercase tracking-[0.2em] text-[10px]" data-testid="referral-code">
          Código de afiliado: <span className="font-mono text-[var(--ag-text)]">{(code || "").toUpperCase()}</span>
        </div>
        <div className="mt-5 text-xs text-[var(--ag-text-dim)] inline-flex items-center gap-1.5">
          Redirigiendo a registro <ArrowRight size={12} weight="bold" />
        </div>
      </div>
    </div>
  );
}
